module.exports = __webpack_public_path__ + "static/media/qr.704364f5.svg";